import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const createBagSize = createAction(ACTION.CREATE_BAG_SIZE.REQUEST, data => data);
